import FaqsPageEmpty from './FaqsPageEmpty';

export default FaqsPageEmpty;
